var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        title: "添加人员",
        width: "500px",
        loading: _vm.loading,
        height: "auto",
        top: _vm.top,
      },
      on: { success: _vm.sure },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "div",
        { staticClass: "addLottery overflowOuto" },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "form",
              attrs: {
                model: _vm.form,
                "label-width": "auto",
                size: "small",
                rules: _vm.rules,
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "userInfo" } },
                [
                  _c(
                    "template",
                    { slot: "label" },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100px" },
                          attrs: { placeholder: "请选择" },
                          on: { change: _vm.onLabelChange },
                          model: {
                            value: _vm.form.userInfo.label,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.userInfo, "label", $$v)
                            },
                            expression: "form.userInfo.label",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "手机号码", value: "tel" },
                          }),
                          _c("el-option", {
                            attrs: { label: "邮箱", value: "Email" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.form.userInfo.label === "tel"
                    ? [
                        _vm.form.userInfo.label === "tel"
                          ? _c(
                              "el-input",
                              {
                                staticStyle: { width: "280px" },
                                attrs: {
                                  clearable: "",
                                  placeholder: "请输入",
                                  maxlength:
                                    _vm.form?.userInfo?.value
                                      ?.newPhoneAreacode === "86"
                                      ? 11
                                      : 15,
                                  "show-word-limit": "",
                                },
                                on: { input: _vm.delNumber },
                                model: {
                                  value: _vm.form.userInfo.value.tel,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form.userInfo.value,
                                      "tel",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "form.userInfo.value.tel",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100px" },
                                    attrs: {
                                      slot: "prepend",
                                      placeholder: "请选择",
                                      filterable: "",
                                    },
                                    slot: "prepend",
                                    model: {
                                      value:
                                        _vm.form.userInfo.value
                                          .newPhoneAreacode,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form.userInfo.value,
                                          "newPhoneAreacode",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "form.userInfo.value.newPhoneAreacode",
                                    },
                                  },
                                  _vm._l(_vm.smsAreaList, function (group) {
                                    return _c(
                                      "el-option-group",
                                      {
                                        key: group.label,
                                        attrs: { label: group.label },
                                      },
                                      _vm._l(group.options, function (item) {
                                        return _c(
                                          "el-option",
                                          {
                                            key: item.areaCode,
                                            attrs: {
                                              label: `+${item.areaCode} ${item.areaChineseName}`,
                                              value: item.areaCode,
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: { float: "left" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(item.areaChineseName)
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  float: "right",
                                                  color: "#8492a6",
                                                  "font-size": "13px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "+" + _vm._s(item.areaCode)
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }),
                                      1
                                    )
                                  }),
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                  _vm.form.userInfo.label === "Email"
                    ? _c("el-autocomplete", {
                        staticStyle: { width: "280px" },
                        attrs: {
                          "trigger-on-focus": false,
                          "fetch-suggestions": _vm.querySearch,
                          placeholder: "请输入邮箱号",
                        },
                        model: {
                          value: _vm.form.userInfo.value.Email,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.userInfo.value,
                              "Email",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.userInfo.value.Email",
                        },
                      })
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "exportScriptFooter",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary", loading: _vm.loading },
              on: {
                click: function ($event) {
                  return _vm.sure(1)
                },
              },
            },
            [_vm._v("保存")]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary", loading: _vm.loading },
              on: {
                click: function ($event) {
                  return _vm.sure(2)
                },
              },
            },
            [_vm._v("保存并新增下一个")]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small", loading: _vm.loading },
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }